import { ComboBoxItemModel } from "@genexus/chameleon-controls-library/dist/types/components/combo-box/types";
import { TeamData } from "./select-user-team";

export const mapTeamsToComboBoxItemModel = (
  teams: TeamData[]
): ComboBoxItemModel[] => {
  return teams?.map(team => {
    return {
      value: team.id,
      caption: team.name
    };
  });
};
